import { BaseModel } from '../shared/models/base.model';
import { Cargo } from './cargo.model';
import { Contrato } from './contrato.model';
import { Encargo } from './encargo.model';

export class Profissional extends BaseModel {
    cargoId: number;
    encargoId: number;
    contratoId: number;
    baseHora: number = 168;
    valorSalarioHoraBaixo: number;
    valorSalarioHoraMedio: number;
    valorSalarioHoraAlto: number;
    piCotaBaixo: number;
    piCotaMedio: number;
    piCotaAlto: number;
    vrBaixo: number;
    vrMedio: number;
    vrAlto: number;
    ajudaCustoBaixo: number;
    ajudaCustoMedio: number;
    ajudaCustoAlto: number;
    beneficioBaixo: number;
    beneficioMedio: number;
    beneficioAlto: number;
    totalBeneficios: number;
    ibrati: number;
    encMensaisAnuais: number;
    maodeobra: number;
    custoHoraBaixo: number = 0;
    custoHoraMedio: number = 0;
    custoHoraAlto: number = 0;
    custoCooperado: number = 0;
    ativo: boolean = true;
    cargo: Cargo = new Cargo();
    contrato: Contrato = new Contrato();
    encargo: Encargo = new Encargo();
    idCargoSenioridade: number;
    descricaoCargoSenioridade: string;
    idMetricaTipo: number;
    descricaoMetricaTipo: string;
}